import { useState, useEffect } from "react";
import img from "../images/vehiclepage-bg3.webp";
import logo from "../images/Aombre-round-logo.png";
import { GiCarDoor } from "react-icons/gi";
import { FaUserFriends, FaSuitcaseRolling, FaCogs } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function VehiclePage() {
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getTypeFromClass = (vehicleClass) => {
    const mapping = {
      Compact: "compact",
      "Compact SUV": "suv",
      "Fullsize SUV": "suv",
      Standard: "standard",
      Economy: "economy",
      Intermediate: "intermediate",
    };
    
    return mapping[vehicleClass] || "economy";
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        const response = await fetch(baseUrl+"fleet_details",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();

        // Define desired order
        const desiredOrder = [
          "Economy",
          "Compact",
          "Intermediate",
          "Compact SUV",
          "Standard SUV",
          "Full Size SUV",
          "Premium SUV",
          "Special SUV",
          "Standard Convertible",
          "Mini Van",
          "Luxury",
          "Standard Pickup",
          "Cargo Van",
        ];

        const transformedData = desiredOrder
          .filter((key) => result[key]) // only include cars that exist
          .map((key) => {
            const vehicle = result[key];
            return {
              class: key,
              seats: vehicle.seat_count,
              bags: vehicle.luggage_count,
              doors: vehicle.door_count,
              transmission: "Automatic",
              AC: "AC",
              image: vehicle.image_path,
              country: "us",
              type: getTypeFromClass(key),
            };
          });

        setData(transformedData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredCars = data.filter((car) => {
    return (
      (selectedCountry === "" || car.country === selectedCountry) &&
      (selectedType === "" || car.type === selectedType)
    );
  });

  return (
    <>
      <div>
        {/* Page Banner */}
        <div className="relative w-full mt-12">
          <img
            src={img}
            alt="Vehicles Banner"
            className="w-full h-[300px] object-cover"
          />

          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* Heading + Subheading */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-3xl sm:text-5xl font-bold text-white drop-shadow-lg">
              Discover the Road Ahead
            </h1>
            <p className="mt-3 text-lg sm:text-xl text-gray-200 max-w-2xl">
              Premium vehicles, unbeatable comfort, and total freedom to travel.
            </p>
          </div>
        </div>

        {/* Search Section */}
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center mt-8 mb-6 px-4">
          {/* Left Heading */}
          <h2 className="text-2xl font-bold font-primary mb-4 sm:mb-0 text-[#353535]">
            Rental Car <span className="text-[#ca8032]"> Options</span>
          </h2>

          {/* Right Search Inputs */}
          {/* <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
           

            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="border p-2 rounded w-full sm:w-48 focus:outline-none focus:border-[#ca8032] focus:ring-1 focus:ring-[#ca8032]"
            >
              <option value="">Select Vehicle Type</option>
              <option value="economy">Economy</option>
              <option value="compact">Compact</option>
              <option value="intermediate">Intermediate</option>
              <option value="suv">SUV</option>
              <option value="van">Van</option>
            </select>
          </div> */}
        </div>

        {/* Car Grid */}
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 mb-12">
          {loading ? (
            <div className="col-span-full flex justify-center items-center flex-col">
              <img
                src={logo}
                alt="Loading..."
                className="w-48 h-48 rounded-full animate-spin"
              />
              <p className="text-gray-500">Loading Vehicles...</p>
            </div>
          ) : error ? (
            <p className="col-span-full text-center text-red-500">
              Error: {error}
            </p>
          ) : filteredCars.length > 0 ? (
            filteredCars.map((car, index) => (
              <div
                className="shadow-lg p-4 bg-white rounded-lg flex flex-col justify-between"
                key={index}
              >
                {/* Car Title */}
                <div className="mb-2">
                  <h2 className="text-lg font-bold font-primary text-[#006039]">
                    {car.class}
                    <span className="font-medium text-sm italic ">
                      {" "}
                      or similar
                    </span>
                  </h2>

                  {/* <p className="text-gray-600 font-semibold">{car.class}</p> */}
                </div>

                {/* Car Image */}
                <img
                  src={car.image}
                  alt={`${car.carname} - ${car.class}`}
                  className="w-full h-40 object-contain mb-4"
                />

                {/* Car Features */}
                <div className="flex flex-wrap justify-around  text-[#006039] text-sm">
                  <div className="flex items-center bg-[#edebec] p-2 rounded m-1">
                    <FaUserFriends title="Seats" />
                    <span className="px-2">{car.seats}</span>
                  </div>
                  <div className="flex items-center bg-[#edebec] p-2 rounded m-1">
                    <FaSuitcaseRolling title="Bags" />
                    <span className="px-2">{car.bags}</span>
                  </div>
                  <div className="flex items-center bg-[#edebec] p-2 rounded m-1">
                    <GiCarDoor title="Doors" />
                    <span className="px-2">{car.doors}</span>
                  </div>
                  {/* <div className="flex items-center bg-[#edebec] p-2 rounded m-1">
                    <FaCogs title="Transmission" />
                    <span className="px-2">{car.transmission}</span>
                  </div> */}
                </div>

                {/* View Details Button */}
                <button
                  className="mt-4 w-full bg-[#ca8032] text-white py-2 rounded hover:bg-[#b97128] transition"
                  onClick={() => navigate("/")}
                >
                  Book Now
                </button>
              </div>
            ))
          ) : (
            <p className="col-span-full text-center text-gray-500">
              No cars found.
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default VehiclePage;
